import { BaseTool } from '../BaseTool';

export class UndoTool extends BaseTool {
    id = 'EDIT_UNDO';
    name = 'Undo';
    cursor = 'default';

    onActivate(): void {
        this.context?.bimStore.undo();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

export class RedoTool extends BaseTool {
    id = 'EDIT_REDO';
    name = 'Redo';
    cursor = 'default';

    onActivate(): void {
        this.context?.bimStore.redo();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

export class PrintTool extends BaseTool {
    id = 'FILE_PRINT';
    name = 'Print';
    cursor = 'default';

    onActivate(): void {
        window.print();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
